import { MessageCircle, AlertTriangle, Lightbulb, CheckCircle } from 'lucide-react';

export interface Anotacao {
  id: string;
  pagina: number;
  posX: number;
  posY: number;
  texto: string;
  tipo: string;
  resolvido: boolean;
  createdAt: string;
  user: { id: string; nome: string; role: string };
  respostas: Array<{
    id: string;
    texto: string;
    createdAt: string;
    user: { id: string; nome: string; role: string };
  }>;
}

interface AnnotationPinProps {
  anotacao: Anotacao;
  index: number;
  isSelected: boolean;
  onClick: () => void;
}

const tipoIcons = {
  comentario: MessageCircle,
  sugestao: Lightbulb,
  problema: AlertTriangle,
};

export function AnnotationPin({ anotacao, index, isSelected, onClick }: AnnotationPinProps) {
  const Icon = tipoIcons[anotacao.tipo as keyof typeof tipoIcons] || MessageCircle;
  const resolved = anotacao.resolvido;

  return (
    <button
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      className={`absolute z-10 transform -translate-x-1/2 -translate-y-1/2 group transition-all duration-150 ${
        isSelected ? 'scale-125 z-20' : 'hover:scale-110'
      }`}
      style={{ left: `${anotacao.posX}%`, top: `${anotacao.posY}%` }}
      title={`${anotacao.user.nome}: ${anotacao.texto.slice(0, 50)}...`}
    >
      <div className={`relative flex items-center justify-center w-7 h-7 rounded-full shadow-md border-2 transition-colors ${
        resolved
          ? 'bg-green-100 border-green-400 text-green-600'
          : isSelected
            ? 'bg-blue-600 border-blue-700 text-white'
            : anotacao.tipo === 'problema'
              ? 'bg-red-100 border-red-400 text-red-600 hover:bg-red-200'
              : anotacao.tipo === 'sugestao'
                ? 'bg-amber-100 border-amber-400 text-amber-600 hover:bg-amber-200'
                : 'bg-blue-100 border-blue-400 text-blue-600 hover:bg-blue-200'
      }`}>
        {resolved ? (
          <CheckCircle className="w-4 h-4" />
        ) : (
          <Icon className="w-3.5 h-3.5" />
        )}
        <span className="absolute -top-1.5 -right-1.5 bg-gray-700 text-white text-[9px] w-4 h-4 rounded-full flex items-center justify-center font-bold">
          {index + 1}
        </span>
        {anotacao.respostas.length > 0 && (
          <span className="absolute -bottom-1 -right-1 bg-blue-500 text-white text-[8px] w-3.5 h-3.5 rounded-full flex items-center justify-center">
            {anotacao.respostas.length}
          </span>
        )}
      </div>
    </button>
  );
}
